import api from '@/modules/api/api';

import { QueryV1GetOnboardingCategories } from './onboarding.types';

export async function apiV1GetOnboardingCategories() {
  return api.get<QueryV1GetOnboardingCategories>(
    'v1',
    '/onboarding/categories',
  );
}
apiV1GetOnboardingCategories.requestKey = 'v1-get-onboarding-categories';
